import { render } from "./secAbout.vue?vue&type=template&id=3488484c&scoped=true"
import script from "./secAbout.vue?vue&type=script&lang=js"
export * from "./secAbout.vue?vue&type=script&lang=js"

import "./secAbout.vue?vue&type=style&index=0&id=3488484c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3488484c"]])

export default __exports__